import {  faChevronDown, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, {   useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'use-debounce';
import { getLanguage } from '../../RTK/Slice/UserSlice';
import { Backdrop, Fade, Modal } from '@mui/material';
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { useParams } from 'react-router-dom';
import { getAllCommentsOfPostAPI, replyCommentAPI } from '../../RTK/Slice/PageSlice';
import { toast } from 'react-toastify';
import ExtractModal from '../Utils/ExtractModal';
import ListComments from '../Utils/ListComments';



const AllCommentComponent =  () => {


    // For Save Data
    const [excelData , setExcelData ] = useState([]) ; 


    // For Control Show Time Mneu 
    const [showTime , setShowTime] = useState(false) ; 

    // For Store Choose Time
    const [timer , setTime] = useState("") ; 

    // For Make Translation
    const {t} = useTranslation() ;

    // For Rely Comment Field
    const [replyComment , setReplyComment] = useState('') ; 

    

    // For Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        p: 4,
      };

    // For Control Reply Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // For Selected ID
    const [selectedID , setSelectedID] = useState([]) ; 

    // For Get Token
    const token = useSelector(getToken) ;

    // For Control Extract Modal
    const [openExtractModal, setOpenExtractModal] = useState(false);
    const handleExtractOpen = () => {
        if(selectedID.length > 0 ){
            setOpenExtractModal(true) ; 
            // dispatch(extractDataFromDBAPI({token , selectedID})) ;
        }else{
            toast.info("Please Choose IDs")
        }

    };
    const handleExtractClose = () => setOpenExtractModal(false);


    // For Store Search Input
    const [search , setSearch] = useState("") ; 
    const [value] = useDebounce(search , 300)

    // For Save Copy
    const [copyText , setCopyText] = useState("");

    // For Copy Text Handler
    const copyTextHandler = (text)=>{
        setCopyText(text) ; 
    }

    // For Store Selected Item
    const [selected , setSelected] = useState([]) ; 

    // For Detect Language
    const language = useSelector(getLanguage) ; 

    const [activeLang ] = useState(language ? language : 'ar') ;

    // For Access Params 
    const { pageToken , postId} = useParams();

    // For Get Active User Token
    const activeToken = useSelector(getActiveToken) ; 

 

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Control Show Dropdown menu OS
    const [menuOS , setMenuOS] = useState(false) ; 

    // For Set Os Filter
    const [typeOS , setTypeOS] = useState('all')


    // For CheckBox Choose 
    const checkBoxHandler = (e , ID)=>{

        let isSelectd = e.target.checked ;
        let value = e.target.value ; 
        if (isSelectd){
            setSelected([...selected , value]) ; 
            setSelectedID([...selectedID , ID]);
        }else{
            setSelected((prevDate)=>{
                return prevDate.filter((id)=>{
                    return id !== value
                }) 
            });
            setSelectedID((prevDate)=>{
                return prevDate.filter((id)=>{
                    return id !== ID
                })
            });
        }
    }



    // For Select All Data 
    const selectAllHandler = (e)=>{
        let selectAll = e.target.checked ;
        if(selectAll){
        setSelected(pageComments
        .filter((item)=>value === ''  ? item : item.message.toLowerCase().includes(value))
        .filter((item)=>typeOS === 'all' ? item : item.application.name.includes(typeOS))
        .map((item)=>item.id)) ; 

        // For Save IDs 
        setSelectedID(pageComments
            .filter((item)=>value === ''  ? item : item?.message.toLowerCase().includes(value))
            .filter((item)=>typeOS === 'all' ? item : item?.application?.name.includes(typeOS))
            .map((item)=>item?.from?.id)) ;
        
        // For Save Comment Data
        setExcelData(pageComments
            .filter((item)=>value === ''  ? item : item.message.toLowerCase().includes(value))
            .filter((item)=>typeOS === 'all' ? item : item.application.name.includes(typeOS))
            .map((item)=>Object.assign({},{comment_id : item.id , name :item.from.name , content :item.message , os : item.application.name , user_id : item.from.id }))) ; 
        
        }else{
            setSelected([])
        }
    }

    
    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
        // Convert minutes to milliseconds
        const min = args.t1 * 10000; // 1 minute in milliseconds
        const max = args.t2  * 10000; // 2 minutes in milliseconds
        
        // Generate random number between min and max
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

     // For Get All Comments From API
    useEffect(()=>{
        dispatch(getAllCommentsOfPostAPI({token , userToken: activeToken  , postId}))
    } , [ dispatch]) ;


    // For Access Search In DB Data 
    const {data , status} = useSelector(state => state.ExtractDataFromDBSlice) ;

    // For Acccess Comments
    const {pageComments , statusOfComments} = useSelector(state => state.PageSlice) ; 


    // For Reply Comment Handler
    const replyCommentHandler = ()=>{
        if(replyComment  && timer){
            let time = 0;
            for(let i = 0 ; i < selected.length ;i++) {
                setTimeout(()=>{
                    dispatch(replyCommentAPI({token , userId : excelData[i]?.user_id , comment : replyComment ,userToken : pageToken , commentId : selected[i] })) ; 

                } , time)
                time += getRandomBetween1And2Minutes(timer) ; 
            }
            handleClose()
            const id = toast.loading("Please wait...")
            setTimeout(()=>{
                toast.update(id, {
                    render: "Operation successful!",
                    type: "success",
                    isLoading: false, // Stop the loading spinner
                    autoClose: 3000, // Automatically close after 3 seconds
                  });
            } , time)
            setReplyComment("")
        }else{
            toast.info("Please Write Comment")
        }
        
    }

    // For Render Reply Modal
    const renderReplayModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 300,
              },
            }}
          >
            <Fade in={open}>
                <div className='k-modal my-font' style={style}>

                    <div className='head'>
                        <div className='left'>
                            <h3>{t('replyComment')}</h3>
                            <p>{t('messageReply')}</p>
                        </div>
                        <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('replay')} </label>
                            <textarea value={replyComment} onChange={(e)=>setReplyComment(e.target.value)}  autoFocus placeholder={t('replyComment')} className='message-field' id='message-input'></textarea>
                        </div>

                        <div className='choose-time' onClick={()=>setShowTime(!showTime)}>
                            <p>{timer ? `Between ${timer.t1}0 sec and ${timer.t2}0 sec`: "Time Between Replys"}</p>
                            <FontAwesomeIcon icon={faChevronDown} />
                            
                             <ul className={`list-items ${showTime ? "list-items-show": "" }`}>
                                <li onClick={()=>setTime({t1 : 3 , t2 : 5})} >Between 30sec and 50sec</li>
                                <li onClick={()=>setTime({t1 : 6 , t2 : 8})} >Between 60sec and 80sec</li>
                                <li onClick={()=>setTime({t1 : 5 , t2 : 7})} >Between 50sec and 70sec</li>
                                <li onClick={()=>setTime({t1 : 6 , t2 : 12})} >Between 60sec and 120sec</li>
                            </ul>
                            
                            
                        </div>

                    </div>

                    <div className='btn'>
                        <button onClick={replyCommentHandler} >{t('replay')}</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }


    // For Render Message Modal
    const renderExtractModal = ()=>{
        return( 
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openExtractModal}
            onClose={handleExtractClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >

            <Fade in={openExtractModal}>
                <ExtractModal closeModal={handleExtractClose} data={data} status={status} />
                
            </Fade>
        </Modal>
    )
    }





  return (
    <div>
        <ListComments replay={true} comments={pageComments} statusOfComments={statusOfComments}  />
    </div>
  )
}

export default AllCommentComponent